import { combineReducers } from "redux";
import session from "./session/reducer";
import clientBasicData from "./clientBasicData/reducer";
import uiModals from "./uiModals/reducer";

const rootReducer = combineReducers({
  session,
  clientBasicData,
  uiModals,
});

export default rootReducer;
